import Vue from "vue";
import VueRouter from "vue-router";
import login from "../login.vue"; // 引入登录页组件

Vue.use(VueRouter);

const routes = [
  {
    path: "/login",
    name: "login",
    component: login, // 登录页
  },
  {
    path: "/register",
    name: "register",
    component: () => import("@/register.vue"),
  }, 
  // 后台
  {
    path: "/htIndex",
    component: () => import("@/view/htIndex.vue"),
    redirect: "/htIndex/admin",
    children: [
      {
        path: "/admin",
        name: "admin",
        component: () => import("@/view/admin.vue"),
      },
      {
        path: "/memberManagement",
        name: "MemberManagement",
        component: () => import("@/view/admin.vue"),
      },
      {
        path: "/infoManagement",
        name: "InfoManagement",
        component: () => import("@/view/admin.vue"),
      },
      {
        path: "/adminManagement",
        name: "AdminManagement",
        component: () => import("@/view/admin.vue"),
      },
    ],
  },
  // 官网
  {
    path: "/",
    component: () => import("@/index.vue"), // 主布局
    redirect: "/home",
    children: [
      {
        path: "home",
        name: "home",
        component: () => import("@/view/home.vue"),
      },
    ],
  },
  // 官网里面二手和招商的详情
  {
    path: "/assistantHome",
    component: () => import("@/view/assistantHome.vue"), // 主布局
    redirect: "/assistantHome/postList",
    children: [
      {
        path: "setting",
        name: "setting",
        component: () => import("@/view/components/setting.vue"),
      },
      {
        path: "postList",
        name: "postList",
        component: () => import("@/view/components/postList.vue"),
      },
      {
        path: "postDetail",
        name: "postDetail",
        component: () => import("@/view/components/postDetail.vue"),
      },
      {
        path: "userInfo",
        name: "userInfo",
        component: () => import("@/view/components/userInfo.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history", // 可选：history模式（需服务器支持）
  base: process.env.BASE_URL,
  routes,
});

export default router;
